import {useMutation} from "@tanstack/react-query";
import {changeExpedientRepresentativeMutationOptions} from "./change-expedient-representative.mutation-options";

export function useChangeExpedientRepresentative(id: string) {
  return useMutation(changeExpedientRepresentativeMutationOptions(id));
}
